import React from "react";
import Accordion from '../components/accordion';
import ContactForm from '../components/contactForm';
import EmailProtection from '../components/email-protection';
import Helmet from 'react-helmet';
const Contact = () => (
    <div>
        <Helmet
            title="Neem contact op met de leukste photobooth verhuurder | Gifture.nl"
            meta={[
                {
                    name: 'description',
                    content: `Neem contact op met Gifture Photobooth. We helpen je graag bij vragen! We laten je graag weten of Gifture Photobooth ook een geschikte toevoeging is voor jouw evenement!`
                },
                {
                    name: 'keywords',
                    content: [
                        'photobooth', 'videobooth', 'gifbooth', 'fotobooth',
                        'fotohokje', 'bruiloft', 'gif photobooth', 'huren',
                        'lenen', 'trouwerij', 'evenement', 'feest', 'bedrijfsfeest',
                        'borrel', 'beurzen', 'beurs', 'verhuur'
                    ].join(',')
                },
            ]}
        />
        <div className="hero is-primary">
            <div className="hero-body">
                <div className="container has-text-centered">
                    <h1 className="title">We helpen je graag om van jouw feest een knalfeest te maken!</h1>
                </div>
            </div>
        </div>
        <section className="section">
            <div className="container content">
                <div className="columns">
                    <div className="column is-one-quarter">
                        <Accordion
                            name="faq"
                            items={[
                                {
                                    question: 'Mijn evenement valt buiten jullie regio, maar ik wil de onbemande photobooth laten brengen en halen, kan dat?',
                                    answer: 'Dat kan zeker! Geef tijdens de bestelling aan dat je de photobooth wilt laten bezorgen. Tegen een meerprijs brengen en installeren we de photobooth. We geven je een uitleg over de photobooth en aan het einde van het evenement wordt de photobooth weer opgehaald.'
                                },
                                {
                                    question: 'Wanneer moet de photobooth gehaald en teruggebracht worden?',
                                    answer: `De photobooth staat op de dag van het evenement vanaf 09:00 (tenzij anders overeengekomen) uur klaar op de afhaallocatie.
                                    De photobooth wordt de volgende dag weer voor 10:00 uur teruggebracht bij de afhaallocatie. Als de photobooth op zaterdag wordt gehuurd mag hij op maandag geretouneerd worden. We rekenen hiervoor geen extra kosten.
                                    De photobooth is overigens alleen actief op de dag van het evenement.'`
                                },
                                {
                                    question: 'Hebben jullie stroom nodig?',
                                    answer: `Indien de tijd dat de photobooth actief gebruikt wordt korter is dan 8 uur hebben wij geen stopcontact nodig. De photobooth wordt standaard geleverd met een accu die voldoende
                                    spanning levert om +- 8 uur verlichting op vol vermogen te laten branden. Mocht er langer dan 8 uur gebruik worden gemaakt van de photobooth dan hebben wij aan 1 x 220 volt aansluiting genoeg.
                                    Er wordt in dat geval een spanningskabel van 10 meter bij de photobooth geleverd.`
                                }
                            ]}
                        />
                    </div>
                    <div className="column is-one-quarter">
                        <div className="card">
                            <div className="card-content">
                                <h3 className="has-text-centered">Contactgegevens</h3>
                                <p>
                                    <strong>Heb je nog vragen?</strong> <br/>
                                    E-mail: <EmailProtection address="info@gifture.nl" /> <br/>
                                    Telefoon: <a href="tel:0644066185">+31 (0)6 - 440 661 85</a> <br/>
                                    WhatsApp: <a href="https://api.whatsapp.com/send?phone=31644066185">+31 (0)6 - 440 661 85</a> <br/>
                                </p>
                                <p>
                                    <strong>Ons bezoeken?</strong> <br/>
                                    Gravin Juliana van Stolberglaan 119 <br/>
                                    2263AM, Leidschendam <br/>
                                    Zuid-Holland <br/>
                                </p>
                                <p>
                                    <strong>Volg ons op social media!</strong> <br/>
                                    Facebook: <a href="https://facebook.com/gifturephotobooth" target="_blank">@gifturephotobooth</a><br/>
                                    Instagram: <a href="https://instagram.com/gifture_photobooth" target="_blank">@gifture_photobooth</a><br/>
                                    {/*Reviews:*/}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="column">
                        <div className="card">
                            <div className="card-content">
                                <h3 className="has-text-centered">Stuur ons een berichtje</h3>
                                <ContactForm />
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </section>
    </div>
)

export default Contact



// WEBPACK FOOTER //
// ./src/pages/contact.js